<mds-dialog [dialogTitle]="data().title">
    @if (data().bodyText && data().bodyText.length > 0) {
        <mds-dialog-content>
            <div class="flex flex-col pb-medpace">
                <span [innerHTML]="data().bodyText"></span>
            </div>
        </mds-dialog-content>
    }

    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            @if (data().showCancelButton) {
                <mds-button
                    [id]="'cancel-btn'"
                    [label]="data().cancelButtonLabel || 'Cancel'"
                    variant="outline"
                    [color]="'neutral'"
                    (clickEvent)="cancel()"
                />
            }
            <mds-button
                [id]="'okay-btn'"
                (clickEvent)="confirm()"
                [label]="data().okayButtonLabel || 'Okay'"
                [variant]="data().showCancelButton ? 'filled' : 'outline'"
                [color]="data().showCancelButton ? 'primary' : 'neutral'"
            />
        </div>
    </mds-dialog-actions>
</mds-dialog>
